module.exports = __webpack_public_path__ + "static/scale-model-of-arizona-history-museum-in-tucson-arizona-8bf1157f2b37db2404e5816ab072d49c.png";